import { ForbiddenSticker } from '@/assets/images';

const Forbidden = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-transparent overflow-y-auto">
      <ForbiddenSticker className="flex-shrink-0" />
      <h1 className="text-[32px] font-bold text-brand-primary-darkest mt-10 mb-3">
        Access Denied!
      </h1>
      <span className="font-medium text-base text-neutral-n7">
        Sorry, we don&apos;t have permission to view this page.
      </span>
    </div>
  );
};

export default Forbidden;
